module.exports = __webpack_public_path__ + "img/1.8a23e54d.png";